namespace TabAurous {
    export interface CommonBOM {
        StockBomId?: number;
        StockId?: number;
        Line_No?: number;
        ProductId?: number;
        BOMProductId?: number;
        BOMAttributeId?: number;
        SettingId?: number;
        StoneStatusId?: number;
        CertificateNo?: string;
        Lab?: string;
        Pieces?: number;
        Weight?: number;
        StdPurity?: number;
        CalcOnId?: number;
        BomRate?: number;
        BomAmount?: number;
        Remarks?: string;
        Purity?: number;
        PureWeight?: number;
        IsCustomerItem?: boolean;
    }
}
